import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/HomeMenuNav.module.css';
import { useI18n } from '../i18n/I18nContext';

const publicPath = process.env.PUBLIC_URL;

const MenuTile = ({ className, title, subtitle, to, imageUrl, id }) => {
  const imageStyle = imageUrl
    ? { backgroundImage: `url('${publicPath}${imageUrl}')` }
    : undefined;
  const image = <div className={styles.menuImage} style={imageStyle}></div>;
  const text = (
    <div className={styles.tileContent}>
      <div>
        <h3 className={styles.tileTitle}>{title}</h3>
        <p className={styles.tileSubtitle}>{subtitle}</p>
      </div>
    </div>
  );

  if (!to) {
    return <div id={id} className={`${styles.menu} ${styles[className]}`}>{image}{text}</div>;
  }

  return (
    <Link to={publicPath + to} className={`${styles.menu} ${styles[className]}`}>
      {image}{text}
    </Link>
  );
};

const HomeMenuNav = () => {
  const { t } = useI18n();

  return (
    <div className={styles.menuWrapper}>
      <div className={styles.menuContainer}>
        <div className={styles.menuBox}>
          <div>
            <p className={styles.introTitle}>Dare to taste something different?</p>
            <p className={styles.introText}>
              Wir stehen für kontinuierliche Frische, Zuverlässigkeit &amp; Qualität. Unsere jahrelange Arbeit im Bereich des Caterings hat uns stets an Erfahrungen und Ideen wachsen lassen.
              Gern probieren wir Neues aus, ohne unsere Bodenständigkeit und Klassiker aus den Augen zu verlieren.
            </p>
          </div>
        </div>

        <MenuTile className="menu1" title={t('menu.bar')} subtitle={t('menu.barSubtitle')} to="/Bar" />
        <MenuTile className="menu2" title={t('menu.catering')} subtitle={t('menu.cateringSubtitle')} to="/Delicious" />
        <MenuTile id="artisan-breads" className="small3" title={t('menu.artisanBreads')} subtitle={t('menu.artisanBreadsSubtitle')} imageUrl="/images/breads/dinkel-bread1.webp" to="/Artisan-Breads" />
        <MenuTile className="small1" title={t('menu.hotDrinks')} subtitle={t('menu.hotDrinksSubtitle')} to="/Coffee" />
        <MenuTile className="small2" title={t('menu.desserts')} subtitle={t('menu.dessertsSubtitle')} to="/Desserts" />
      </div>
    </div>
  );
};

export default HomeMenuNav;
